import './style.css';
import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, Fragment, toDisplayString, createCommentVNode, pushScopeId, popScopeId, reactive, watch, toRefs, toRef, createVNode, Transition, withCtx, withDirectives, vShow, normalizeClass, normalizeStyle, renderList, ref, unref, withModifiers, renderSlot, onUnmounted, resolveComponent, createTextVNode } from 'vue';
import createUploader from '@yanxiu/uploader-client';
import { v4 } from 'uuid';

var uploadingInfo_vue_vue_type_style_index_0_scoped_true_lang = '';

var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const _sfc_main$8 = defineComponent({
  props: {
    uploadFile: {
      type: Object,
      default: () => {
      }
    },
    uploadFileList: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const uploadFileName = computed(() => props.uploadFile.file && props.uploadFile.file.name);
    const queueLeftCount = computed(
      () => props.uploadFileList.length === 0 ? 0 : props.uploadFileList.length - 1
    );
    const errorCount = computed(
      () => props.uploadFileList.filter((item) => item.status == 3).length
    );
    return {
      uploadFileName,
      queueLeftCount,
      errorCount
    };
  }
});
const _withScopeId$7 = (n) => (pushScopeId("data-v-2e46ce1c"), n = n(), popScopeId(), n);
const _hoisted_1$8 = { class: "uploading-info" };
const _hoisted_2$8 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("div", { class: "timer" }, null, -1));
const _hoisted_3$7 = { class: "info" };
const _hoisted_4$6 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u6B63\u5728\u4E0A\u4F20\uFF1A", -1));
const _hoisted_5$5 = { class: "upload-file-name" };
const _hoisted_6$5 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\uFF0C", -1));
const _hoisted_7$4 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u6709", -1));
const _hoisted_8$4 = { class: "queue-left-count" };
const _hoisted_9$4 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u4E2A\u6587\u4EF6\u7B49\u5F85\u4E2D\uFF0C", -1));
const _hoisted_10$4 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u4E0A\u4F20\u5931\u8D25", -1));
const _hoisted_11$3 = { class: "error-count" };
const _hoisted_12$3 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u4E2A\uFF0C", -1));
const _hoisted_13$3 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u70B9\u51FB", -1));
const _hoisted_14$2 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("span", null, "\u8FDB\u5EA6", -1));
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    _hoisted_2$8,
    createElementVNode("div", _hoisted_3$7, [
      (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _hoisted_4$6,
        createElementVNode("span", _hoisted_5$5, toDisplayString(_ctx.uploadFileName), 1),
        _hoisted_6$5
      ], 64)) ,
      _ctx.queueLeftCount ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        _hoisted_7$4,
        createElementVNode("span", _hoisted_8$4, toDisplayString(_ctx.queueLeftCount), 1),
        _hoisted_9$4
      ], 64)) : createCommentVNode("", true),
      _ctx.errorCount ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
        _hoisted_10$4,
        createElementVNode("span", _hoisted_11$3, toDisplayString(_ctx.errorCount), 1),
        _hoisted_12$3
      ], 64)) : createCommentVNode("", true),
      _hoisted_13$3,
      createElementVNode("span", {
        class: "see",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-see"))
      }, "\u67E5\u770B"),
      _hoisted_14$2
    ])
  ]);
}
var UploadingInfo = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-2e46ce1c"]]);

function useFormat() {
  const formatFileSize = (size) => {
    let fsText;
    if (size < 1048576)
      fsText = (size / 1024).toFixed(2) + "KB";
    else if (size === 1048576)
      fsText = "1MB";
    else if (size > 1048576 && size < 1073741824)
      fsText = (size / (1024 * 1024)).toFixed(2) + "MB";
    else if (size > 1048576 && size === 1073741824)
      fsText = "1GB";
    else if (size > 1073741824 && size < 1099511627776)
      fsText = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    else
      fsText = "1TB+";
    return fsText;
  };
  const formatTime = (time) => {
    let date = new Date(time);
    let y = date.getFullYear(), m = date.getMonth() + 1, d = date.getDate();
    let nowDate = new Date();
    let nowY = nowDate.getFullYear();
    let nowTime = nowDate.getTime();
    let diff = nowTime - time;
    let dd = Math.floor(diff / (1e3 * 60 * 60 * 24));
    let dh = Math.floor(diff / (1e3 * 60 * 60));
    let dm = Math.floor(diff / (1e3 * 60));
    if (nowY > y)
      return y + "\u5E74" + m + "\u6708" + d + "\u65E5";
    else if (Math.floor(dd) > 1)
      return m + "\u6708" + d + "\u65E5";
    else if (dd === 1)
      return "\u6628\u5929";
    else if (dh >= 1)
      return "" + dh + "\u5C0F\u65F6\u524D";
    else if (dm >= 5)
      return "" + dm + "\u5206\u949F\u524D";
    else
      return "\u521A\u521A";
  };
  return {
    formatFileSize,
    formatTime
  };
}

function useModal(value, notifySyncState) {
  const modal = reactive({
    visible: false,
    isWrapShow: false
  });
  watch(value, (val) => {
    modal.visible = val;
    if (val) {
      document.body.classList.add("dialog-parent--hidden");
      modal.isWrapShow = val;
    } else {
      setTimeout(() => {
        modal.isWrapShow = val;
        document.body.classList.remove("dialog-parent--hidden");
      }, 300);
    }
  });
  function close() {
    notifySyncState(false);
  }
  return {
    ...toRefs(modal),
    close
  };
}

const GB = 1024 ** 3;
const MB = 1024 ** 2;
const CATEGORY_TAB_MAP = {
  all: "\u5168\u90E8",
  document: "\u6587\u6863",
  audio: "\u97F3\u9891",
  video: "\u89C6\u9891",
  img: "\u56FE\u7247",
  other: "\u5176\u5B83"
};
const MIMETYPE_REG_MAP = {
  doc: /^application\/(msword|vnd.openxmlformats-officedocument.wordprocessingml.document)$/i,
  xls: /^application\/(vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet)$/i,
  ppt: /^application\/(vnd.ms-powerpoint|vnd.openxmlformats-officedocument.presentationml.presentation)$/i,
  pdf: /^application\/pdf$/i,
  audio: /^audio\//i,
  video: /^video\//i,
  image: /^image\//i
};
const FILETYPE_IN_CATEGORY = {
  document: ["txt", "doc", "docx", "docm", "dot", "dotx", "dotm", "ppt", "pptx", "pptm", "pps", "ppsx", "ppsm", "pot", "potx", "potm", "xls", "xlsx", "xlsm", "xlt", "xltx", "xltm", "csv", "pdf"],
  audio: ["mp3", "wma", "flac", "m4a", "ogg", "ape", "amr", "wav", "aac", "aiff", "caf"],
  video: ["3gp", "asf", "avi", "dat", "dv", "flv", "f4v", "m2t", "m3u8", "m4v", "mj2", "mjpeg", "mkv", "mov", "mp4", "mpe", "mpg", "mpeg", "mts", "qt", "rm", "rmvb", "swf", "ts", "vob", "wmv", "webm"],
  img: ["jpg", "jpeg", "jpg", "gif", "png", "bmp", "webp"]
};
function getMaterialTypeTabs(types) {
  if (types.length === 0) {
    types = ["all", "document", "audio", "video", "img", "other"];
  }
  return types.map((key) => ({
    key,
    value: CATEGORY_TAB_MAP[key]
  }));
}
function getFileType(mimetype) {
  return Object.keys(MIMETYPE_REG_MAP).find((key) => MIMETYPE_REG_MAP[key].test(mimetype)) || "";
}
function getCategoryWithFileType(fileType) {
  return Object.keys(FILETYPE_IN_CATEGORY).find((key) => FILETYPE_IN_CATEGORY[key].includes(fileType)) || "other";
}
function getFileAcceptType(category, limitType) {
  const defaultFileAcceptType = Object.assign(FILETYPE_IN_CATEGORY);
  if (Object.prototype.toString.call(limitType) === "[object Array]") {
    const fileAcceptType2 = {};
    const types = [...limitType];
    const props = Object.keys(defaultFileAcceptType);
    props.forEach((key) => {
      fileAcceptType2[key] = defaultFileAcceptType[key].filter((str) => {
        const idx = types.indexOf(str);
        if (idx > -1) {
          types.splice(idx, 1);
          return true;
        }
        return false;
      });
    });
    fileAcceptType2["other"] = [...types];
    fileAcceptType2["all"] = [...limitType];
    return fileAcceptType2;
  }
  const fileAcceptType = Object.assign(defaultFileAcceptType, limitType);
  fileAcceptType["other"] = fileAcceptType["other"] || [];
  fileAcceptType["all"] = category.reduce((prev, curr) => [...prev, ...fileAcceptType[curr] || []], []);
  if (category.includes("other") && fileAcceptType["other"].length === 0) {
    fileAcceptType["all"] = [];
  }
  return fileAcceptType;
}
function getFileAcceptSize(category, limitSize) {
  const defaultFileAcceptSize = {
    document: 500 * MB,
    audio: 100 * MB,
    video: 2 * GB,
    img: 10 * MB,
    other: 2 * GB
  };
  const fileAcceptSize = {};
  const props = Object.keys(defaultFileAcceptSize);
  for (const key of props) {
    if (Object.prototype.toString.call(limitSize) === "[object Object]") {
      fileAcceptSize[key] = Math.min(defaultFileAcceptSize[key], limitSize[key] || defaultFileAcceptSize[key]);
      continue;
    }
    if (Object.prototype.toString.call(limitSize) === "[object Number]") {
      fileAcceptSize[key] = Math.min(defaultFileAcceptSize[key], limitSize);
      continue;
    }
    fileAcceptSize[key] = defaultFileAcceptSize[key];
  }
  fileAcceptSize["all"] = category.reduce((prev, curr) => Math.max(prev, fileAcceptSize[curr] || 0), 0);
  fileAcceptSize["all"] = fileAcceptSize["all"] > 0 ? fileAcceptSize["all"] : 2 * GB;
  return fileAcceptSize;
}
function getFileSuffix(fileName) {
  return fileName.replace(/.+\./, "").toLowerCase();
}

var _imports_0 = "data:image/png;base64,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";

var uploadingList_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$7 = defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: true
    },
    stickyDistance: {
      type: Number,
      default: 10
    },
    uploadFileList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const { visible, isWrapShow, close } = useModal(toRef(props, "modelValue"), (state) => emit("update:modelValue", state));
    const drag = reactive({
      x: null,
      y: null
    });
    const wrapStyle = computed(() => props.sticky ? { overflow: "hidden" } : {});
    const confirmStyle = computed(() => {
      return drag.x != null ? {
        width: "auto",
        top: 0
      } : {};
    });
    const contentStyle = computed(() => {
      let style = {};
      if (props.draggable) {
        if (drag.x !== null)
          style.left = `${drag.x}px`;
        if (drag.y !== null)
          style.top = `${drag.y}px`;
      }
      return style;
    });
    function onWrapClick() {
    }
    function handleMousedown() {
    }
    const { formatFileSize } = useFormat();
    function formatFileTypeClasses(mimetype) {
      return getFileType(mimetype);
    }
    return {
      visible,
      isWrapShow,
      close,
      wrapStyle,
      confirmStyle,
      contentStyle,
      onWrapClick,
      handleMousedown,
      formatFileSize,
      formatFileTypeClasses
    };
  }
});
const _withScopeId$6 = (n) => (pushScopeId("data-v-f9c294f4"), n = n(), popScopeId(), n);
const _hoisted_1$7 = { class: "uploading-list dialog" };
const _hoisted_2$7 = { class: "dialog-mask" };
const _hoisted_3$6 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("h3", { class: "title" }, "\u6587\u4EF6\u4E0A\u4F20\u5217\u8868", -1));
const _hoisted_4$5 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("i", { class: "close-icon" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 12 12",
    height: "12",
    width: "12"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6.834,6.138 L11.232,1.74 C11.454,1.518 11.454,1.152 11.232,0.93 L11.208,0.906 C10.986,0.684 10.62,0.684 10.398,0.906 L6,5.31 L1.602,0.906 C1.38,0.684 1.014,0.684 0.792,0.906 L0.768,0.93 C0.54,1.152 0.54,1.518 0.768,1.74 L5.166,6.138 L0.768,10.536 C0.546,10.758 0.546,11.124 0.768,11.346 L0.792,11.37 C1.014,11.592 1.38,11.592 1.602,11.37 L6,6.972 L10.398,11.37 C10.62,11.592 10.986,11.592 11.208,11.37 L11.232,11.346 C11.454,11.124 11.454,10.758 11.232,10.536 L6.834,6.138 Z",
      fill: "currentColor"
    })
  ])
], -1));
const _hoisted_5$4 = [
  _hoisted_4$5
];
const _hoisted_6$4 = { class: "body" };
const _hoisted_7$3 = {
  key: 0,
  class: "list"
};
const _hoisted_8$3 = { class: "item-inner" };
const _hoisted_9$3 = { class: "file" };
const _hoisted_10$3 = { class: "name" };
const _hoisted_11$2 = { class: "info" };
const _hoisted_12$2 = {
  key: 0,
  class: "size"
};
const _hoisted_13$2 = { class: "progress-or-status" };
const _hoisted_14$1 = {
  key: 0,
  class: "progress"
};
const _hoisted_15$1 = {
  key: 1,
  class: "prepare"
};
const _hoisted_16$1 = {
  key: 2,
  class: "error"
};
const _hoisted_17$1 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("span", { class: "s1" }, "\u4E0A\u4F20\u5931\u8D25", -1));
const _hoisted_18$1 = ["onClick"];
const _hoisted_19$1 = ["onClick"];
const _hoisted_20$1 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("span", null, "\u5220\u9664", -1));
const _hoisted_21$1 = [
  _hoisted_20$1
];
const _hoisted_22$1 = {
  key: 1,
  class: "is-completed"
};
const _hoisted_23$1 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_24$1 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("p", null, "\u6682\u65E0\u4E0A\u4F20\u5185\u5BB9", -1));
const _hoisted_25$1 = [
  _hoisted_23$1,
  _hoisted_24$1
];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    createVNode(Transition, { name: "fade" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", _hoisted_2$7, null, 512), [
          [vShow, _ctx.visible]
        ])
      ]),
      _: 1
    }),
    createElementVNode("div", {
      class: normalizeClass(["dialog-wrap", { "wrap--hide": !_ctx.isWrapShow }]),
      style: normalizeStyle(_ctx.wrapStyle),
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.onWrapClick && _ctx.onWrapClick(...args))
    }, [
      createElementVNode("div", {
        class: normalizeClass({ "dialog-center-fixed": !_ctx.draggable })
      }, [
        createVNode(Transition, { name: "ease" }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              class: "dialog-confirm",
              style: normalizeStyle(_ctx.confirmStyle)
            }, [
              createElementVNode("div", {
                ref: "contentRef",
                class: normalizeClass(["dialog-content", { "dialog-content--drag": _ctx.draggable }]),
                style: normalizeStyle(_ctx.contentStyle)
              }, [
                createElementVNode("div", {
                  class: "header",
                  onMousedown: _cache[1] || (_cache[1] = (...args) => _ctx.handleMousedown && _ctx.handleMousedown(...args))
                }, [
                  _hoisted_3$6,
                  createElementVNode("a", {
                    class: "close",
                    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.close && _ctx.close(...args))
                  }, _hoisted_5$4)
                ], 32),
                createElementVNode("div", _hoisted_6$4, [
                  _ctx.uploadFileList.length ? (openBlock(), createElementBlock("ul", _hoisted_7$3, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.uploadFileList, (item) => {
                      return openBlock(), createElementBlock("li", {
                        key: item.id,
                        class: "item"
                      }, [
                        createElementVNode("div", _hoisted_8$3, [
                          createElementVNode("div", {
                            class: normalizeClass(["icon", _ctx.formatFileTypeClasses(item.file.type)])
                          }, null, 2),
                          createElementVNode("div", _hoisted_9$3, [
                            createElementVNode("div", _hoisted_10$3, toDisplayString(item.file.name), 1),
                            createElementVNode("div", _hoisted_11$2, [
                              item.status !== 3 ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
                                createElementVNode("span", null, toDisplayString(_ctx.formatFileSize(item.file.size)), 1)
                              ])) : createCommentVNode("", true),
                              createElementVNode("div", _hoisted_13$2, [
                                item.status === 1 ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
                                  createElementVNode("div", {
                                    class: "progress-rate",
                                    style: normalizeStyle({ width: item.progress + "%" })
                                  }, null, 4)
                                ])) : createCommentVNode("", true),
                                item.status === 0 ? (openBlock(), createElementBlock("span", _hoisted_15$1, "\u7B49\u5F85\u4E2D")) : createCommentVNode("", true),
                                item.status === 3 ? (openBlock(), createElementBlock("span", _hoisted_16$1, [
                                  _hoisted_17$1,
                                  createElementVNode("span", {
                                    class: "s2",
                                    onClick: ($event) => _ctx.$emit("on-re-upload", item.id)
                                  }, "\u70B9\u51FB\u91CD\u65B0\u4E0A\u4F20", 8, _hoisted_18$1)
                                ])) : createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          createElementVNode("a", {
                            class: "item-abort",
                            onClick: ($event) => _ctx.$emit("on-remove", item.id)
                          }, _hoisted_21$1, 8, _hoisted_19$1)
                        ])
                      ]);
                    }), 128))
                  ])) : (openBlock(), createElementBlock("div", _hoisted_22$1, _hoisted_25$1))
                ]),
                createCommentVNode("", true)
              ], 6)
            ], 4), [
              [vShow, _ctx.visible]
            ])
          ]),
          _: 1
        })
      ], 2)
    ], 6)
  ]);
}
var UploadingList = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__scopeId", "data-v-f9c294f4"]]);

var searchInput_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$6 = defineComponent({
  props: {
    modelValue: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const currentValue = ref(props.modelValue);
    watch(() => props.modelValue, (val) => currentValue.value = val);
    const inputRef = ref();
    const focused = ref(false);
    function handleInput(event) {
      const { value } = event.target;
      emit("update:modelValue", value);
      currentValue.value = value;
      emit("on-change", event);
    }
    function handleFocus() {
      focused.value = true;
    }
    function handleBlur() {
      focused.value = false;
    }
    function handleClick() {
      inputRef.value.focus();
      emit("on-search", unref(currentValue));
    }
    return {
      currentValue,
      inputRef,
      focused,
      handleInput,
      handleFocus,
      handleBlur,
      handleClick
    };
  }
});
const _withScopeId$5 = (n) => (pushScopeId("data-v-7d6bda08"), n = n(), popScopeId(), n);
const _hoisted_1$6 = { class: "search-input-wrapper" };
const _hoisted_2$6 = ["value"];
const _hoisted_3$5 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("i", { class: "icon-material-search" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 20 20",
    height: "20",
    width: "20"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z",
      stroke: "currentColor",
      fill: "none",
      "stroke-linejoin": "round",
      "stroke-linecap": "round"
    })
  ])
], -1));
const _hoisted_4$4 = [
  _hoisted_3$5
];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("div", {
      class: normalizeClass(["input-wrapper", { "is--focus": _ctx.focused }])
    }, [
      createElementVNode("input", {
        ref: "inputRef",
        class: "input-inner",
        type: "text",
        placeholder: "\u8F93\u5165\u7D20\u6750\u540D\u79F0\u67E5\u8BE2",
        value: _ctx.currentValue,
        onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
        onFocus: _cache[1] || (_cache[1] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
        onBlur: _cache[2] || (_cache[2] = (...args) => _ctx.handleBlur && _ctx.handleBlur(...args))
      }, null, 40, _hoisted_2$6),
      createElementVNode("button", {
        class: "search-btn",
        type: "button",
        onClick: _cache[3] || (_cache[3] = withModifiers((...args) => _ctx.handleClick && _ctx.handleClick(...args), ["prevent"]))
      }, _hoisted_4$4)
    ], 2)
  ]);
}
var SearchInput = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-7d6bda08"]]);

var uploader_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$5 = defineComponent({
  props: {
    acceptTypes: {
      type: Array,
      default: () => []
    },
    acceptSize: {
      type: [Object, Number],
      default: 2 * 1024 * 1024 * 1024
    },
    requestConfig: {
      type: Object,
      default: () => ({})
    },
    isPType: {
      type: String,
      default: ""
    },
    business: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit, expose }) {
    let uploadClient = null;
    const accept = computed(() => {
      if (props.acceptTypes.length) {
        return props.acceptTypes.map((ext) => "." + ext).join(",");
      }
      return "*";
    });
    const fileQueue = ref([]);
    watch(
      fileQueue,
      (queue) => {
        emit("update-file-list", queue);
        const isProcessing = queue.some((item) => item.status == 1 /* Processing */);
        if (isProcessing)
          return;
        next();
      },
      { deep: true }
    );
    function next() {
      const order = fileQueue.value.findIndex((item) => item.status == 0 /* Prepare */);
      const uploadFile = fileQueue.value[order];
      if (uploadFile) {
        uploadFile.status = 1 /* Processing */;
        fileQueue.value.splice(order, 1, uploadFile);
        upload(uploadFile);
      }
    }
    function updateUploadFileStatus(id, status, progress) {
      const order = fileQueue.value.findIndex((item) => item.id == id);
      const uploadFile = fileQueue.value[order];
      if (uploadFile) {
        switch (status) {
          case 9 /* Remove */:
            if (uploadFile.status == 1 /* Processing */) {
              cancelUpload();
            }
            fileQueue.value.splice(order, 1);
            return;
        }
        uploadFile.progress = progress || 0;
        uploadFile.status = status;
        fileQueue.value.splice(order, 1, uploadFile);
      }
    }
    function upload(uploadFile) {
      const { file, id } = uploadFile;
      const callback = {
        onProgress,
        onSuccess,
        onError
      };
      uploadClient.start(file, id, callback);
      emit("update-file", uploadFile);
    }
    function cancelUpload() {
      if (uploadClient) {
        uploadClient.stop();
      }
    }
    function onProgress(payload) {
      const { id, progress } = payload;
      const percent = Math.floor(progress.percent * 100) / 100;
      updateUploadFileStatus(id, 1 /* Processing */, percent);
    }
    function onSuccess(payload) {
      const { id, data } = payload;
      console.log(">> success::", data);
      updateUploadFileStatus(id, 2 /* Success */);
      emit("on-success", data);
    }
    function onError(payload) {
      const { id, info } = payload;
      console.log(">> error::", info);
      updateUploadFileStatus(id, 3 /* Error */);
      emit("on-error", info);
      if (info.code == 401) {
        uploadClient = null;
      }
    }
    async function reUploadByKey(id) {
      if (uploadClient == null) {
        uploadClient = await createUploader(props.requestConfig, props.isPType, props.business);
      }
      updateUploadFileStatus(id, 0 /* Prepare */);
    }
    function removeUploadFileFromTheQueue(id) {
      updateUploadFileStatus(id, 9 /* Remove */);
    }
    const fileInputRef = ref();
    function onChangeFileHandler(e) {
      const input = e.currentTarget;
      const files = input.files;
      if (files) {
        const uploadFileList = fileCheckAndFilter(files);
        if (uploadFileList) {
          fileQueue.value = fileQueue.value.concat(uploadFileList);
        }
      }
      input.value = "";
    }
    async function handleUpload() {
      if (uploadClient == null) {
        uploadClient = await createUploader(props.requestConfig, props.isPType, props.business);
      }
      fileInputRef.value.click();
    }
    function fileCheckAndFilter(files) {
      if (files) {
        let fileList = Array.prototype.map.call(files, (file) => file);
        fileList = checkFileType(fileList);
        fileList = checkFileSize(fileList);
        return fileList.map((file) => genUploadFile(file));
      }
    }
    function checkFileType(files) {
      const limitType = props.acceptTypes;
      const errorTypeList = [];
      const fileList = files.filter((file) => {
        const fileType = getFileSuffix(file.name);
        if (!/^[A-Za-z0-9]{0,10}$/.test(fileType)) {
          errorTypeList.push(file);
          return false;
        }
        if (["exe"].includes(fileType)) {
          errorTypeList.push(file);
          return false;
        }
        if (limitType.length == 0 || limitType.includes(fileType)) {
          return true;
        } else {
          errorTypeList.push(file);
          return false;
        }
      });
      if (errorTypeList.length) {
        console.log(">> check type error::", errorTypeList);
        emit("on-error", {
          code: 1001,
          file: errorTypeList
        });
      }
      return fileList;
    }
    function checkFileSize(files) {
      const limitSize = props.acceptSize;
      const errorSizeList = [];
      const fileList = files.filter((file) => {
        const fileSize = file.size;
        if (limitSize instanceof Map) {
          const category = getCategoryWithFileType(getFileSuffix(file.name));
          const limit = limitSize.get(category);
          if (fileSize <= limit) {
            return true;
          } else {
            errorSizeList.push(file);
            return false;
          }
        }
        if (fileSize <= limitSize) {
          return true;
        } else {
          errorSizeList.push(file);
          return false;
        }
      });
      if (errorSizeList.length) {
        console.log(">> check size error::", errorSizeList);
        emit("on-error", {
          code: 1002,
          file: errorSizeList
        });
      }
      return fileList;
    }
    function genUploadFile(file) {
      return {
        progress: 0,
        status: 0 /* Prepare */,
        file,
        id: v4()
      };
    }
    expose({
      removeUploadFileFromTheQueue,
      reUploadByKey
    });
    return {
      fileInputRef,
      accept,
      onChangeFileHandler,
      handleUpload
    };
  }
});
const _withScopeId$4 = (n) => (pushScopeId("data-v-9f573cbe"), n = n(), popScopeId(), n);
const _hoisted_1$5 = { class: "uploader" };
const _hoisted_2$5 = ["accept"];
const _hoisted_3$4 = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("span", { class: "upload-btn" }, "+\u672C\u5730\u4E0A\u4F20", -1));
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("input", {
      ref: "fileInputRef",
      type: "file",
      accept: _ctx.accept,
      multiple: "",
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChangeFileHandler && _ctx.onChangeFileHandler(...args))
    }, null, 40, _hoisted_2$5),
    createElementVNode("span", {
      class: "upload-btn-wrap",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleUpload && _ctx.handleUpload(...args))
    }, [
      renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_3$4
      ], true)
    ])
  ]);
}
var Uploader = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-9f573cbe"]]);

var viewModeSwitcher_vue_vue_type_style_index_0_scoped_true_lang = '';

function getDefaultModeList() {
  return [
    { label: "\u5355\u5217\u5C55\u793A", value: 1 },
    { label: "\u53CC\u5217\u5C55\u793A", value: 2 }
  ];
}
const _sfc_main$4 = defineComponent({
  props: {
    modelValue: {
      type: Number,
      default: 1
    }
  },
  setup(props, { emit }) {
    const modeList = getDefaultModeList();
    const modeListVisible = ref(false);
    function setModeListVisible(val) {
      modeListVisible.value = val;
    }
    function handleSwitch(value) {
      emit("update:modelValue", value);
      setModeListVisible(false);
    }
    return {
      modeList,
      modeListVisible,
      setModeListVisible,
      handleSwitch
    };
  }
});
const _withScopeId$3 = (n) => (pushScopeId("data-v-1e3d90f2"), n = n(), popScopeId(), n);
const _hoisted_1$4 = { class: "switcher" };
const _hoisted_2$4 = {
  key: 0,
  class: "single-icon"
};
const _hoisted_3$3 = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 18 16",
  width: "18",
  height: "16"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M17,0 C17.5522847,0 18,0.477562934 18,1.06666667 L18,14.9333333 C18,15.5224371 17.5522847,16 17,16 L1,16 C0.44771525,16 0,15.5224371 0,14.9333333 L0,1.06666667 C0,0.477562934 0.44771525,0 1,0 L17,0 Z M16.5,1.6 L1.5,1.6 L1.5,14.4 L16.5,14.4 L16.5,1.6 Z M14.5,11.52 L14.5,12.5866667 L3.5,12.5866667 L3.5,11.52 L14.5,11.52 Z M14.5,8.85333333 L14.5,9.92 L3.5,9.92 L3.5,8.85333333 L14.5,8.85333333 Z M14.5,6.18666667 L14.5,7.25333333 L3.5,7.25333333 L3.5,6.18666667 L14.5,6.18666667 Z M14.5,3.52 L14.5,4.58666667 L3.5,4.58666667 L3.5,3.52 L14.5,3.52 Z",
    fill: "currentColor"
  })
], -1));
const _hoisted_4$3 = [
  _hoisted_3$3
];
const _hoisted_5$3 = {
  key: 1,
  class: "double-icon"
};
const _hoisted_6$3 = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 18 16",
  width: "18",
  height: "16"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M17,0 C17.5522847,0 18,0.477562934 18,1.06666667 L18,14.9333333 C18,15.5224371 17.5522847,16 17,16 L1,16 C0.44771525,16 0,15.5224371 0,14.9333333 L0,1.06666667 C0,0.477562934 0.44771525,0 1,0 L17,0 Z M8.5,11.199 L1.5,11.199 L1.5,14.4 L8.5,14.4 L8.5,11.199 Z M16.5,11.199 L10,11.199 L10,14.4 L16.5,14.4 L16.5,11.199 Z M8.5,6.399 L1.5,6.399 L1.5,9.599 L8.5,9.599 L8.5,6.399 Z M16.5,6.399 L10,6.399 L10,9.599 L16.5,9.599 L16.5,6.399 Z M8.5,1.599 L1.5,1.6 L1.5,4.799 L8.5,4.799 L8.5,1.599 Z M16.5,1.6 L10,1.599 L10,4.799 L16.5,4.799 L16.5,1.6 Z",
    fill: "currentColor"
  })
], -1));
const _hoisted_7$2 = [
  _hoisted_6$3
];
const _hoisted_8$2 = { class: "dropdown-mode-list" };
const _hoisted_9$2 = { class: "mode-list" };
const _hoisted_10$2 = ["onClick"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "view-mode-switcher",
    onMouseenter: _cache[0] || (_cache[0] = () => _ctx.setModeListVisible(true)),
    onMouseleave: _cache[1] || (_cache[1] = () => _ctx.setModeListVisible(false))
  }, [
    createElementVNode("div", _hoisted_1$4, [
      _ctx.modelValue === 1 ? (openBlock(), createElementBlock("i", _hoisted_2$4, _hoisted_4$3)) : (openBlock(), createElementBlock("i", _hoisted_5$3, _hoisted_7$2))
    ]),
    createVNode(Transition, { name: "zoom-in-top" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", _hoisted_8$2, [
          createElementVNode("ul", _hoisted_9$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modeList, (item, index) => {
              return openBlock(), createElementBlock("li", {
                key: index,
                class: normalizeClass(["mode-item", { "active": _ctx.modelValue === item.value }]),
                onClick: ($event) => _ctx.handleSwitch(item.value)
              }, [
                createElementVNode("span", null, toDisplayString(item.label), 1)
              ], 10, _hoisted_10$2);
            }), 128))
          ])
        ], 512), [
          [vShow, _ctx.modeListVisible]
        ])
      ]),
      _: 1
    })
  ], 32);
}
var ViewModeSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-1e3d90f2"]]);

var selector_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$3 = defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const checkboxClasses = computed(() => {
      return ["checkbox", { "checkbox--checked": props.modelValue, "checkbox--disabled": props.disabled }];
    });
    const radioClasses = computed(() => {
      return ["radio", { "radio--checked": props.modelValue, "radio--disabled": props.disabled }];
    });
    function onChanged(ev) {
      if (props.disabled)
        return;
      const input = ev.target;
      emit("update:modelValue", input.checked);
    }
    return {
      checkboxClasses,
      radioClasses,
      onChanged
    };
  }
});
const _withScopeId$2 = (n) => (pushScopeId("data-v-e81e3360"), n = n(), popScopeId(), n);
const _hoisted_1$3 = { class: "selector" };
const _hoisted_2$3 = {
  key: 0,
  class: "radio"
};
const _hoisted_3$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("i", { class: "radio-inner" }, null, -1));
const _hoisted_4$2 = ["checked", "disabled"];
const _hoisted_5$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("i", { class: "checkbox-inner" }, null, -1));
const _hoisted_6$2 = ["checked", "disabled"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    _ctx.mode === 1 ? (openBlock(), createElementBlock("span", _hoisted_2$3, [
      createElementVNode("span", {
        class: normalizeClass(_ctx.radioClasses)
      }, [
        _hoisted_3$2,
        createElementVNode("input", {
          type: "radio",
          class: "radio-input",
          checked: _ctx.modelValue,
          disabled: _ctx.disabled,
          onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChanged && _ctx.onChanged(...args))
        }, null, 40, _hoisted_4$2)
      ], 2)
    ])) : (openBlock(), createElementBlock("span", {
      key: 1,
      class: normalizeClass(_ctx.checkboxClasses)
    }, [
      _hoisted_5$2,
      createElementVNode("input", {
        type: "checkbox",
        class: "checkbox-input",
        checked: _ctx.modelValue,
        disabled: _ctx.disabled,
        onChange: _cache[1] || (_cache[1] = (...args) => _ctx.onChanged && _ctx.onChanged(...args))
      }, null, 40, _hoisted_6$2)
    ], 2))
  ]);
}
var Selector = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-e81e3360"]]);

var pager_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$2 = defineComponent({
  props: {
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      currentPage: props.pageIndex,
      currentPageSize: props.pageSize
    });
    const pageNum = computed(() => {
      const num = Math.ceil(props.total / state.currentPageSize);
      if (num == 0) {
        return 1;
      } else {
        return num;
      }
    });
    const disabledPrev = computed(() => state.currentPage == 1);
    const disabledNext = computed(() => state.currentPage == pageNum.value);
    watch(
      () => props.pageIndex,
      (val) => state.currentPage = val
    );
    function prev() {
      const current = state.currentPage;
      if (current <= 1) {
        return false;
      }
      changePage(current - 1);
    }
    function next() {
      const current = state.currentPage;
      if (current >= pageNum.value) {
        return false;
      }
      changePage(current + 1);
    }
    function fastPrev() {
      const page = state.currentPage - 5;
      if (page > 0) {
        changePage(page);
      } else {
        changePage(1);
      }
    }
    function fastNext() {
      const page = state.currentPage + 5;
      if (page > pageNum.value) {
        changePage(pageNum.value);
      } else {
        changePage(page);
      }
    }
    function changePage(page) {
      if (state.currentPage !== page) {
        state.currentPage = page;
        emit("on-change", page);
      }
    }
    return {
      ...toRefs(state),
      pageNum,
      disabledPrev,
      disabledNext,
      prev,
      next,
      fastPrev,
      fastNext,
      changePage
    };
  }
});
const _withScopeId$1 = (n) => (pushScopeId("data-v-7ceca3e9"), n = n(), popScopeId(), n);
const _hoisted_1$2 = { class: "pager" };
const _hoisted_2$2 = { class: "page" };
const _hoisted_3$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("a", null, [
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-arrow-back" }, [
    /* @__PURE__ */ createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ createElementVNode("path", {
        fill: "currentColor",
        d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
      })
    ])
  ])
], -1));
const _hoisted_4$1 = [
  _hoisted_3$1
];
const _hoisted_5$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("a", null, "1", -1));
const _hoisted_6$1 = [
  _hoisted_5$1
];
const _hoisted_7$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("a", null, [
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-arrow-back" }, [
    /* @__PURE__ */ createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ createElementVNode("path", {
        fill: "currentColor",
        d: "M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224zm256 0a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224z"
      })
    ])
  ]),
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-more" }, "\xB7\xB7\xB7")
], -1));
const _hoisted_8$1 = [
  _hoisted_7$1
];
const _hoisted_9$1 = {
  key: 4,
  class: "page-item page-item-active"
};
const _hoisted_10$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("a", null, [
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-arrow-forward" }, [
    /* @__PURE__ */ createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ createElementVNode("path", {
        fill: "currentColor",
        d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688zm-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
      })
    ])
  ]),
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-more" }, "\xB7\xB7\xB7")
], -1));
const _hoisted_11$1 = [
  _hoisted_10$1
];
const _hoisted_12$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("a", null, [
  /* @__PURE__ */ createElementVNode("i", { class: "page-icon icon-arrow-forward" }, [
    /* @__PURE__ */ createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ createElementVNode("path", {
        fill: "currentColor",
        d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
      })
    ])
  ])
], -1));
const _hoisted_13$1 = [
  _hoisted_12$1
];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("ul", _hoisted_2$2, [
      createElementVNode("li", {
        class: normalizeClass(["page-prev", { "page-disabled": _ctx.disabledPrev }]),
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.prev && _ctx.prev(...args))
      }, _hoisted_4$1, 2),
      createElementVNode("li", {
        class: normalizeClass(["page-item", { "page-item-active": _ctx.disabledPrev }]),
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.changePage(1))
      }, _hoisted_6$1, 2),
      _ctx.currentPage > 5 ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: "page-item-jump-prev",
        onClick: _cache[2] || (_cache[2] = (...args) => _ctx.fastPrev && _ctx.fastPrev(...args))
      }, _hoisted_8$1)) : createCommentVNode("", true),
      _ctx.currentPage === 5 ? (openBlock(), createElementBlock("li", {
        key: 1,
        class: "page-item",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.changePage(_ctx.currentPage - 3))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage - 3), 1)
      ])) : createCommentVNode("", true),
      _ctx.currentPage - 2 > 1 ? (openBlock(), createElementBlock("li", {
        key: 2,
        class: "page-item",
        onClick: _cache[4] || (_cache[4] = ($event) => _ctx.changePage(_ctx.currentPage - 2))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage - 2), 1)
      ])) : createCommentVNode("", true),
      _ctx.currentPage - 1 > 1 ? (openBlock(), createElementBlock("li", {
        key: 3,
        class: "page-item",
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.changePage(_ctx.currentPage - 1))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage - 1), 1)
      ])) : createCommentVNode("", true),
      _ctx.currentPage !== 1 && _ctx.currentPage !== _ctx.pageNum ? (openBlock(), createElementBlock("li", _hoisted_9$1, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage), 1)
      ])) : createCommentVNode("", true),
      _ctx.currentPage + 1 < _ctx.pageNum ? (openBlock(), createElementBlock("li", {
        key: 5,
        class: "page-item",
        onClick: _cache[6] || (_cache[6] = ($event) => _ctx.changePage(_ctx.currentPage + 1))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage + 1), 1)
      ])) : createCommentVNode("", true),
      _ctx.currentPage + 2 < _ctx.pageNum ? (openBlock(), createElementBlock("li", {
        key: 6,
        class: "page-item",
        onClick: _cache[7] || (_cache[7] = ($event) => _ctx.changePage(_ctx.currentPage + 2))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage + 2), 1)
      ])) : createCommentVNode("", true),
      _ctx.pageNum - _ctx.currentPage === 4 ? (openBlock(), createElementBlock("li", {
        key: 7,
        class: "page-item",
        onClick: _cache[8] || (_cache[8] = ($event) => _ctx.changePage(_ctx.currentPage + 3))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.currentPage + 3), 1)
      ])) : createCommentVNode("", true),
      _ctx.pageNum - _ctx.currentPage >= 5 ? (openBlock(), createElementBlock("li", {
        key: 8,
        class: "page-item-jump-next",
        onClick: _cache[9] || (_cache[9] = (...args) => _ctx.fastNext && _ctx.fastNext(...args))
      }, _hoisted_11$1)) : createCommentVNode("", true),
      _ctx.pageNum > 1 ? (openBlock(), createElementBlock("li", {
        key: 9,
        class: normalizeClass(["page-item", { "page-item-active": _ctx.disabledNext }]),
        onClick: _cache[10] || (_cache[10] = ($event) => _ctx.changePage(_ctx.pageNum))
      }, [
        createElementVNode("a", null, toDisplayString(_ctx.pageNum), 1)
      ], 2)) : createCommentVNode("", true),
      createElementVNode("li", {
        class: normalizeClass(["page-next", { "page-disabled": _ctx.disabledNext }]),
        onClick: _cache[11] || (_cache[11] = (...args) => _ctx.next && _ctx.next(...args))
      }, _hoisted_13$1, 2)
    ])
  ]);
}
var Pager = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-7ceca3e9"]]);

var tooltip_vue_vue_type_style_index_0_scoped_true_lang = '';

const _sfc_main$1 = defineComponent({
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  setup() {
    const tooltipVisible = ref(false);
    function setTooltipVisible(val) {
      tooltipVisible.value = val;
    }
    return {
      tooltipVisible,
      setTooltipVisible
    };
  }
});
const _hoisted_1$1 = { class: "tooltip-content" };
const _hoisted_2$1 = { class: "inner" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "tooltip",
    onMouseenter: _cache[0] || (_cache[0] = () => _ctx.setTooltipVisible(true)),
    onMouseleave: _cache[1] || (_cache[1] = () => _ctx.setTooltipVisible(false))
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true),
    createVNode(Transition, { name: "tooltip-fade-in" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", _hoisted_1$1, [
          createElementVNode("div", _hoisted_2$1, toDisplayString(_ctx.content), 1)
        ], 512), [
          [vShow, _ctx.tooltipVisible]
        ])
      ]),
      _: 1
    })
  ], 32);
}
var Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-2f773c0c"]]);

function usePolling(func, interval) {
  const timer = ref(-1);
  function polling(...args) {
    clear();
    const callback = func.bind(this, args);
    callback();
    timer.value = setInterval(callback, interval);
  }
  function clear() {
    if (timer.value > 0) {
      clearInterval(timer.value);
      timer.value = -1;
    }
  }
  return {
    polling,
    clear
  };
}

function isEmptyObject(obj) {
  let property;
  for (property in obj) {
    return false;
  }
  return true;
}

function request(url, method, config, params) {
  if (isEmptyObject(config)) {
    throw new Error("request config cannot be empty.");
  }
  const headers = new Headers();
  headers.append("X-DT-accessToken", config.accessToken);
  headers.append("X-DT-clientId", config.clientId);
  headers.append("Content-Type", "application/json");
  if (method == "POST") {
    return fetch(`${config.apiHost}${url}`, {
      headers,
      method,
      body: JSON.stringify(params.data),
      mode: "cors"
    }).then((response) => response.json()).then((data) => data.data);
  }
  const searchParams = new URLSearchParams(params.queries);
  const qs = searchParams.toString();
  return fetch(`${config.apiHost}${url}?${qs}`, {
    headers,
    method,
    mode: "cors"
  }).then((response) => response.json()).then((data) => data.data);
}

const MATERIAL_PUBLISH_API = "/material-center/material/v1/publish";
const MATERIAL_SEARCH_API = "/material-center/search/v2";
const MATERIAL_LIST_API = "/material-center/list";

var index_vue_vue_type_style_index_0_scoped_true_lang = '';

var index_vue_vue_type_style_index_1_lang = '';

const _sfc_main = defineComponent({
  components: {
    UploadingInfo,
    UploadingList,
    SearchInput,
    Uploader,
    ViewModeSwitcher,
    Selector,
    Pager,
    Tooltip
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    category: {
      type: Array,
      default: () => ["all", "document", "audio", "video", "img", "other"]
    },
    selectedMaterials: {
      type: Array,
      default: () => []
    },
    mode: {
      type: Number,
      default: 0
    },
    usableMode: {
      type: String,
      default: "strict"
    },
    disabledDeselect: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 20
    },
    limitType: {
      type: [Object, Array],
      default: void 0
    },
    limitSize: {
      type: [Object, Number],
      default: void 0
    },
    previewEnable: {
      type: Boolean,
      default: false
    },
    otherEnable: {
      type: Boolean,
      default: false
    },
    otherName: {
      type: String,
      default: "\u590D\u5236\u7D20\u6750"
    },
    requestConfig: {
      type: Object,
      default: () => ({})
    },
    isPType: {
      type: String,
      default: ""
    },
    viewSwitch: {
      type: Number,
      default: 1
    },
    business: {
      type: String,
      default: ""
    }
  },
  emits: ["on-ok", "on-error", "on-preview", "update:modelValue", "on-other"],
  setup(props, { emit }) {
    const { visible, isWrapShow, close } = useModal(toRef(props, "modelValue"), (state) => emit("update:modelValue", state));
    watch(isWrapShow, (show) => {
      if (show) {
        currentMaterialType.value = materialTypes.value[0].key;
        selection.selected = [...props.selectedMaterials.map((item) => item.materialId)];
      } else {
        currentMaterialType.value = "";
        materialList.value = [];
        clear();
        searchKey.value = "";
      }
    });
    const materialTypes = computed(() => getMaterialTypeTabs(props.category));
    const currentMaterialType = ref("");
    watch(currentMaterialType, (materialType) => {
      if (materialType) {
        page.pageIndex = 1;
        polling();
      }
    });
    function onTypeChanged(materialType) {
      currentMaterialType.value = materialType;
    }
    const materialList = ref([]);
    const isPicture = ref(false);
    watch(materialList, (list) => {
      const noTranscoding = list.every((item) => item.materialStatus != "transcoding");
      if (noTranscoding) {
        clear();
      }
    });
    const { formatFileSize, formatTime } = useFormat();
    const { polling, clear } = usePolling(getMaterialList, 3e3);
    function getMaterialList() {
      const materialType = currentMaterialType.value === "all" ? props.category.filter((c) => c !== "all").join(",") : currentMaterialType.value;
      const materialSubType = props.limitType ? acceptTypes.value.join(",") : "";
      const keywords = searchKey.value.trim();
      request(MATERIAL_SEARCH_API, "POST", props.requestConfig, {
        data: {
          materialType,
          materialSubType,
          pageIndex: page.pageIndex,
          pageSize: page.pageSize,
          searchKey: keywords
        }
      }).then((data) => {
        materialList.value = data.rows;
        page.total = data.total;
      }).catch(() => {
        clear();
      });
    }
    function getMaterialListByIds(ids) {
      return request(MATERIAL_LIST_API, "POST", props.requestConfig, {
        data: {
          materialIds: ids
        }
      });
    }
    const page = reactive({
      pageIndex: 1,
      pageSize: 10,
      total: 0
    });
    function onPageChanged(pageIndex) {
      page.pageIndex = pageIndex;
      polling();
    }
    const searchKey = ref("");
    function handleSearchWithSearchKey() {
      page.pageIndex = 1;
      polling();
    }
    function handleSearchKeyChanged() {
      if (unref(searchKey) === "") {
        page.pageIndex = 1;
        polling();
      }
    }
    const viewMode = ref(props.viewSwitch);
    function handleViewModeSwitch() {
    }
    const uploaderRef = ref();
    const uploading = reactive({
      uploadFile: {},
      uploadFileList: [],
      isShowUploadingList: false
    });
    function handleReUploadByKey(id) {
      uploaderRef.value.reUploadByKey(id);
    }
    function handleUploadFileRemove(id) {
      uploaderRef.value.removeUploadFileFromTheQueue(id);
    }
    const materialAcceptTypesMap = computed(() => {
      return getFileAcceptType(props.category, props.limitType);
    });
    const acceptTypes = computed(() => {
      const defaultAcceptTypes = [];
      if (currentMaterialType.value) {
        return materialAcceptTypesMap.value[currentMaterialType.value];
      }
      return defaultAcceptTypes;
    });
    const materialAcceptSizeMap = computed(() => {
      return getFileAcceptSize(props.category, props.limitSize);
    });
    const acceptSize = computed(() => {
      const defaultAcceptSize = 2 * 1024 * 1024 * 1024;
      if (currentMaterialType.value) {
        if (["all", "other"].includes(currentMaterialType.value)) {
          return Object.keys(materialAcceptSizeMap.value).reduce((prev, curr) => prev.set(curr, materialAcceptSizeMap.value[curr]), /* @__PURE__ */ new Map());
        }
        return materialAcceptSizeMap.value[currentMaterialType.value];
      }
      return defaultAcceptSize;
    });
    function handleUploadFileListChanged(uploadFileList) {
      uploading.uploadFileList = uploadFileList.filter((uploadFile) => uploadFile.status != 2);
    }
    function handleUploadFileChanged(uploadFile) {
      uploading.uploadFile = uploadFile;
    }
    async function handleUploadSuccess(data) {
      await publishMaterial(data);
      page.pageIndex = 1;
      polling();
    }
    function publishMaterial(data) {
      return request(MATERIAL_PUBLISH_API, "POST", props.requestConfig, {
        data: {
          materialFullName: data.name,
          materialHash: data.hash,
          materialSize: data.size,
          materialUrl: data.url,
          ispType: data.ispType
        }
      });
    }
    function handleError(msg) {
      emit("on-error", msg);
    }
    const selection = reactive({
      selected: []
    });
    function isNotSyncRemoved(item) {
      if (props.mode == 1) {
        return false;
      }
      return props.disabledDeselect && props.selectedMaterials.findIndex((sm) => sm.materialId == item.materialId) > -1;
    }
    function isSelectable(item) {
      if (props.mode == 1) {
        return true;
      }
      return selection.selected.length < props.limit || selection.selected.includes(item.materialId);
    }
    function isUsable(item) {
      if (props.usableMode == "strict") {
        return item.materialStatus == "usable";
      } else if (props.usableMode == "lax") {
        return item.materialStatus == "usable" || item.materialStatus == "transcoding";
      } else {
        return true;
      }
    }
    function disableSelect(item) {
      return isNotSyncRemoved(item) || !isSelectable(item) || !isUsable(item);
    }
    function handleItemSelect(item) {
      if (disableSelect(item))
        return;
      const id = item.materialId;
      if (props.mode == 1) {
        selection.selected = [];
        selection.selected.push(id);
      } else {
        const index = selection.selected.indexOf(id);
        if (index !== -1) {
          selection.selected.splice(index, 1);
        } else {
          selection.selected.push(id);
        }
      }
    }
    function onCancel() {
      close();
    }
    async function onInsert() {
      if (selection.selected.length == 0)
        return;
      const ids = [...selection.selected];
      const materialList2 = await getMaterialListByIds(ids);
      ids.forEach((id) => {
        if (materialList2.findIndex((item) => item.materialId == id) == -1) {
          const material = props.selectedMaterials.find((item) => item.materialId == id);
          if (material) {
            materialList2.push({ ...material });
          }
        }
      });
      materialList2.sort((a, b) => ids.indexOf(a.materialId) - ids.indexOf(b.materialId));
      emit("on-ok", materialList2);
      close();
    }
    onUnmounted(() => clear());
    return {
      visible,
      isWrapShow,
      currentMaterialType,
      materialTypes,
      onTypeChanged,
      materialList,
      isPicture,
      formatFileSize,
      formatTime,
      ...toRefs(page),
      onPageChanged,
      searchKey,
      handleSearchWithSearchKey,
      handleSearchKeyChanged,
      viewMode,
      handleViewModeSwitch,
      uploaderRef,
      ...toRefs(uploading),
      handleReUploadByKey,
      handleUploadFileRemove,
      materialAcceptTypesMap,
      materialAcceptSizeMap,
      acceptTypes,
      acceptSize,
      handleUploadFileListChanged,
      handleUploadFileChanged,
      handleUploadSuccess,
      handleError,
      ...toRefs(selection),
      disableSelect,
      handleItemSelect,
      onCancel,
      onInsert
    };
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-6564fe17"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "dialog material-dialog element-css-reset" };
const _hoisted_2 = { class: "dialog-mask" };
const _hoisted_3 = { class: "dialog-center-fixed" };
const _hoisted_4 = { class: "dialog-main" };
const _hoisted_5 = { class: "dialog-content" };
const _hoisted_6 = { class: "header" };
const _hoisted_7 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("h3", { class: "title" }, [
  /* @__PURE__ */ createElementVNode("span", null, "\u9009\u62E9\u7D20\u6750 ")
], -1));
const _hoisted_8 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "close-icon" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 12 12",
    height: "12",
    width: "12"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6.834,6.138 L11.232,1.74 C11.454,1.518 11.454,1.152 11.232,0.93 L11.208,0.906 C10.986,0.684 10.62,0.684 10.398,0.906 L6,5.31 L1.602,0.906 C1.38,0.684 1.014,0.684 0.792,0.906 L0.768,0.93 C0.54,1.152 0.54,1.518 0.768,1.74 L5.166,6.138 L0.768,10.536 C0.546,10.758 0.546,11.124 0.768,11.346 L0.792,11.37 C1.014,11.592 1.38,11.592 1.602,11.37 L6,6.972 L10.398,11.37 C10.62,11.592 10.986,11.592 11.208,11.37 L11.232,11.346 C11.454,11.124 11.454,10.758 11.232,10.536 L6.834,6.138 Z",
      fill: "currentColor"
    })
  ])
], -1));
const _hoisted_9 = [
  _hoisted_8
];
const _hoisted_10 = { class: "body" };
const _hoisted_11 = { class: "tabs" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: /* @__PURE__ */ normalizeClass(["material-list"])
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "item-choice" };
const _hoisted_16 = { class: "item" };
const _hoisted_17 = { class: "icon" };
const _hoisted_18 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "icon-mask" }, null, -1));
const _hoisted_19 = ["src"];
const _hoisted_20 = { class: "file" };
const _hoisted_21 = { class: "name" };
const _hoisted_22 = ["title"];
const _hoisted_23 = { class: "info" };
const _hoisted_24 = {
  key: 0,
  class: "size"
};
const _hoisted_25 = { class: "time-or-status" };
const _hoisted_26 = {
  key: 0,
  class: "time"
};
const _hoisted_27 = {
  key: 1,
  class: "status"
};
const _hoisted_28 = {
  key: 0,
  class: "status-desc transcoding",
  title: "\u6B63\u5728\u5904\u7406\u6210\u6D4F\u89C8\u5668\u53EF\u64AD\u653E\u7684\u683C\u5F0F\uFF0C\u5904\u7406\u65F6\u957F\u4E0E\u6587\u4EF6\u5927\u5C0F\u548C\u7F51\u901F\u6709\u5173\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85"
};
const _hoisted_29 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "\u8F6C\u7801\u4E2D", -1));
const _hoisted_30 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "status-desc-helper-icon" }, null, -1));
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
];
const _hoisted_32 = ["title"];
const _hoisted_33 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "\u8F6C\u7801\u5931\u8D25", -1));
const _hoisted_34 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "status-desc-helper-icon" }, null, -1));
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
];
const _hoisted_36 = {
  key: 0,
  class: "file-preview"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "\u9884\u89C8", -1));
const _hoisted_39 = [
  _hoisted_38
];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  key: 1,
  class: "is-empty"
};
const _hoisted_42 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_43 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("p", null, "\u6682\u65E0\u5185\u5BB9\uFF0C\u8BF7\u5148\u4E0A\u4F20\u7D20\u6750", -1));
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
];
const _hoisted_45 = { class: "footer" };
const _hoisted_46 = { class: "tips" };
const _hoisted_47 = { key: 0 };
const _hoisted_48 = { class: "btns" };
const _hoisted_49 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "(", -1));
const _hoisted_50 = { class: "count" };
const _hoisted_51 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, ")", -1));
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UploadingInfo = resolveComponent("UploadingInfo");
  const _component_SearchInput = resolveComponent("SearchInput");
  const _component_Uploader = resolveComponent("Uploader");
  const _component_ViewModeSwitcher = resolveComponent("ViewModeSwitcher");
  const _component_Selector = resolveComponent("Selector");
  const _component_Pager = resolveComponent("Pager");
  const _component_UploadingList = resolveComponent("UploadingList");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode(Transition, { name: "fade" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", _hoisted_2, null, 512), [
          [vShow, _ctx.visible]
        ])
      ]),
      _: 1
    }),
    createElementVNode("div", {
      class: normalizeClass(["dialog-wrap", { "wrap--hide": !_ctx.isWrapShow }])
    }, [
      createElementVNode("div", _hoisted_3, [
        createVNode(Transition, { name: "fade-in-linear" }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", _hoisted_4, [
              createElementVNode("div", _hoisted_5, [
                createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  createElementVNode("a", {
                    class: "close",
                    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onCancel && _ctx.onCancel(...args))
                  }, _hoisted_9)
                ]),
                createElementVNode("div", _hoisted_10, [
                  createElementVNode("div", {
                    class: normalizeClass(["body-inner", { "uploading-info--show": _ctx.uploadFileList.length > 0 }])
                  }, [
                    createVNode(_component_UploadingInfo, {
                      "upload-file": _ctx.uploadFile,
                      "upload-file-list": _ctx.uploadFileList,
                      onOnSee: _cache[1] || (_cache[1] = ($event) => _ctx.isShowUploadingList = true)
                    }, null, 8, ["upload-file", "upload-file-list"]),
                    createElementVNode("div", _hoisted_11, [
                      createElementVNode("ul", null, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.materialTypes, (tab, index) => {
                          return openBlock(), createElementBlock("li", {
                            key: index,
                            class: normalizeClass(["tab", { active: _ctx.currentMaterialType === tab.key }]),
                            onClick: ($event) => _ctx.onTypeChanged(tab.key)
                          }, [
                            createElementVNode("span", null, toDisplayString(tab.value), 1)
                          ], 10, _hoisted_12);
                        }), 128))
                      ]),
                      createVNode(_component_SearchInput, {
                        modelValue: _ctx.searchKey,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.searchKey = $event),
                        onOnSearch: _ctx.handleSearchWithSearchKey,
                        onOnChange: _ctx.handleSearchKeyChanged
                      }, null, 8, ["modelValue", "onOnSearch", "onOnChange"]),
                      createVNode(_component_Uploader, {
                        ref: "uploaderRef",
                        acceptTypes: _ctx.acceptTypes,
                        acceptSize: _ctx.acceptSize,
                        "request-config": _ctx.requestConfig,
                        isPType: _ctx.isPType,
                        business: _ctx.business,
                        onUpdateFileList: _ctx.handleUploadFileListChanged,
                        onUpdateFile: _ctx.handleUploadFileChanged,
                        onOnSuccess: _ctx.handleUploadSuccess,
                        onOnError: _ctx.handleError
                      }, null, 8, ["acceptTypes", "acceptSize", "request-config", "isPType", "business", "onUpdateFileList", "onUpdateFile", "onOnSuccess", "onOnError"]),
                      renderSlot(_ctx.$slots, "tabBarExtraContent", {}, void 0, true),
                      createVNode(_component_ViewModeSwitcher, {
                        modelValue: _ctx.viewMode,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.viewMode = $event),
                        onOnSwitch: _ctx.handleViewModeSwitch
                      }, null, 8, ["modelValue", "onOnSwitch"])
                    ]),
                    createElementVNode("div", {
                      class: normalizeClass(["pane", { "single": _ctx.viewMode === 1 }])
                    }, [
                      _ctx.materialList.length ? (openBlock(), createElementBlock("ul", _hoisted_13, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.materialList, (item) => {
                          return openBlock(), createElementBlock("li", {
                            key: item.materialId,
                            class: normalizeClass(["material-item", { "disabled": _ctx.disableSelect(item), "selected": _ctx.selected.includes(item.materialId) }])
                          }, [
                            createElementVNode("div", {
                              class: normalizeClass(["item-wrapper", { "preview-enable": _ctx.previewEnable }]),
                              onClick: () => _ctx.handleItemSelect(item)
                            }, [
                              createElementVNode("div", _hoisted_15, [
                                createVNode(_component_Selector, {
                                  modelValue: _ctx.selected.includes(item.materialId),
                                  mode: _ctx.mode,
                                  disabled: _ctx.disableSelect(item)
                                }, null, 8, ["modelValue", "mode", "disabled"])
                              ]),
                              createElementVNode("div", _hoisted_16, [
                                createElementVNode("div", _hoisted_17, [
                                  _hoisted_18,
                                  createElementVNode("img", {
                                    src: item.snapshotCover,
                                    alt: ""
                                  }, null, 8, _hoisted_19)
                                ]),
                                createElementVNode("div", _hoisted_20, [
                                  createElementVNode("div", _hoisted_21, [
                                    renderSlot(_ctx.$slots, "fileName", {
                                      filename: item.materialFullName
                                    }, () => [
                                      createElementVNode("div", {
                                        class: "text",
                                        title: item.materialFullName
                                      }, toDisplayString(item.materialFullName), 9, _hoisted_22)
                                    ], true)
                                  ]),
                                  createElementVNode("div", _hoisted_23, [
                                    item.materialStatus !== "error" ? (openBlock(), createElementBlock("div", _hoisted_24, [
                                      createElementVNode("span", null, toDisplayString(_ctx.formatFileSize(item.materialSize)), 1)
                                    ])) : createCommentVNode("", true),
                                    createElementVNode("div", _hoisted_25, [
                                      item.materialStatus === "usable" ? (openBlock(), createElementBlock("div", _hoisted_26, [
                                        createElementVNode("span", null, toDisplayString(_ctx.formatTime(item.gmtCreate)), 1)
                                      ])) : (openBlock(), createElementBlock("div", _hoisted_27, [
                                        item.materialStatus === "transcoding" ? (openBlock(), createElementBlock("span", _hoisted_28, _hoisted_31)) : createCommentVNode("", true),
                                        item.materialStatus === "failed" ? (openBlock(), createElementBlock("span", {
                                          key: 1,
                                          class: "status-desc failed",
                                          title: ["doc", "ppt", "pptx", "docx", "pdf", "xlsx", "xls"].includes(item.materialType) ? "\u8F6C\u7801\u5931\u8D25\u4EC5\u5F71\u54CD\u5728\u7EBF\u9884\u89C8\uFF0C\u4E0B\u8F7D\u540E\u53EF\u6B63\u5E38\u67E5\u770B\u3002\u60A8\u53EF\u4EE5\u5C1D\u8BD5\u4EE5\u4E0B\u64CD\u4F5C\u540E\u91CD\u65B0\u4E0A\u4F20\uFF1A1.\u68C0\u67E5\u6587\u4EF6\u7684\u5B57\u4F53\uFF0C\u5C3D\u91CF\u4F7F\u7528\u5E38\u89C4\u5B57\u4F53\uFF1A\u5B8B\u4F53\u3001\u6977\u4F53\u3001\u9ED1\u4F53\u30022.\u5982\u9700\u6280\u672F\u652F\u6301\u53EF\u62E8\u6253\u5BA2\u670D\u7535\u8BDD4007799010" : "\u8F6C\u7801\u5931\u8D25\u4EC5\u5F71\u54CD\u5728\u7EBF\u9884\u89C8\uFF0C\u4E0B\u8F7D\u540E\u53EF\u6B63\u5E38\u67E5\u770B\u3002\u5982\u9700\u6280\u672F\u652F\u6301\u53EF\u62E8\u6253\u5BA2\u670D\u7535\u8BDD4007799010"
                                        }, _hoisted_35, 8, _hoisted_32)) : createCommentVNode("", true)
                                      ]))
                                    ])
                                  ])
                                ]),
                                _ctx.previewEnable || _ctx.otherEnable ? (openBlock(), createElementBlock("div", _hoisted_36, [
                                  _ctx.previewEnable ? (openBlock(), createElementBlock("span", {
                                    key: 0,
                                    onClick: withModifiers(($event) => _ctx.$emit("on-preview", item), ["stop"])
                                  }, _hoisted_39, 8, _hoisted_37)) : createCommentVNode("", true),
                                  _ctx.otherEnable ? (openBlock(), createElementBlock("span", {
                                    key: 1,
                                    class: "ml12",
                                    onClick: withModifiers(($event) => _ctx.$emit("on-other", item), ["stop"])
                                  }, [
                                    createElementVNode("span", null, toDisplayString(_ctx.otherName), 1)
                                  ], 8, _hoisted_40)) : createCommentVNode("", true)
                                ])) : createCommentVNode("", true)
                              ])
                            ], 10, _hoisted_14)
                          ], 2);
                        }), 128))
                      ])) : (openBlock(), createElementBlock("div", _hoisted_41, _hoisted_44))
                    ], 2)
                  ], 2)
                ]),
                createVNode(_component_Pager, {
                  class: normalizeClass({ "pager--hidden": _ctx.total <= _ctx.pageSize }),
                  "page-index": _ctx.pageIndex,
                  "page-size": _ctx.pageSize,
                  total: _ctx.total,
                  onOnChange: _ctx.onPageChanged
                }, null, 8, ["class", "page-index", "page-size", "total", "onOnChange"]),
                createElementVNode("div", _hoisted_45, [
                  createElementVNode("div", _hoisted_46, [
                    _ctx.limit ? renderSlot(_ctx.$slots, "tips", { key: 0 }, () => [
                      _ctx.mode !== 1 ? (openBlock(), createElementBlock("span", _hoisted_47, "\u5355\u6B21\u6700\u591A\u53EF\u9009\u62E9" + toDisplayString(_ctx.limit) + "\u4E2A\u7D20\u6750", 1)) : createCommentVNode("", true)
                    ], true) : createCommentVNode("", true)
                  ]),
                  createElementVNode("div", _hoisted_48, [
                    createElementVNode("span", {
                      class: "btn cancel",
                      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.onCancel && _ctx.onCancel(...args))
                    }, "\u53D6\u6D88"),
                    createElementVNode("span", {
                      class: normalizeClass(["btn insert", { disabled: _ctx.selected.length === 0 }]),
                      onClick: _cache[5] || (_cache[5] = (...args) => _ctx.onInsert && _ctx.onInsert(...args))
                    }, [
                      createTextVNode(" \u63D2\u5165 "),
                      _ctx.mode !== 1 && _ctx.selected.length !== 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        _hoisted_49,
                        createElementVNode("span", _hoisted_50, toDisplayString(_ctx.selected.length), 1),
                        _hoisted_51
                      ], 64)) : createCommentVNode("", true)
                    ], 2)
                  ])
                ])
              ])
            ], 512), [
              [vShow, _ctx.visible]
            ])
          ]),
          _: 3
        })
      ])
    ], 2),
    createVNode(_component_UploadingList, {
      modelValue: _ctx.isShowUploadingList,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.isShowUploadingList = $event),
      "upload-file-list": _ctx.uploadFileList,
      onOnReUpload: _ctx.handleReUploadByKey,
      onOnRemove: _ctx.handleUploadFileRemove
    }, null, 8, ["modelValue", "upload-file-list", "onOnReUpload", "onOnRemove"])
  ]);
}
var index = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-6564fe17"]]);

export { index as Material, Uploader, getCategoryWithFileType, getFileAcceptSize, getFileAcceptType, getFileSuffix, getFileType, getMaterialTypeTabs };
